import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformPrice',
  standalone: true,
})
export class TransformPricePipe implements PipeTransform {
  transform(value: number, division: boolean = true): string {
    if (value == null) {
      return '€ 0';
    }
    const dollars = division ? value / 100 : value;
    return dollars.toFixed(2) + '€';
  }
}
